import { render, staticRenderFns } from "./OActionButtons.vue?vue&type=template&id=d9004504&scoped=true"
import script from "./OActionButtons.vue?vue&type=script&lang=js"
export * from "./OActionButtons.vue?vue&type=script&lang=js"
import style0 from "./OActionButtons.vue?vue&type=style&index=0&id=d9004504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9004504",
  null
  
)

export default component.exports